export default [
	{
		key: 'timestamp',
		label: 'Date/Time',
		sorteable: false
	},
	{
		key: 'userFullnameRoleName',
		label: 'Changed By User - Role',
		sorteable: false
	},
	{
		key: 'summary',
		label: 'Summary',
		sorteable: false
	},
	{
		key: 'ccl',
		label: 'CCL',
		sorteable: false
	},
	{
		key: 'actions',
		label: 'Copy / Download',
		sorteable: false
	}
];
